module.exports = "<app-header></app-header>\n\n<app-footer></app-footer>\n"